import { Box, Divider, Flex, Text, useColorModeValue, useDisclosure, VStack } from '@chakra-ui/react';
import { IVacanciesProps } from '../../../../../services/hooks/SelectiveProcess/Types';
import LabelWithValueMobilePage from '../../../../../components/Mobile/labelWithValue';
import { IoIosArrowDropdown } from 'react-icons/io';
import MoreDetailVacancyMobilePage from './moreDetailVacancy';

interface IOwnProps {
  item: IVacanciesProps;
}

const CardVacancyMobilePage: React.FC<IOwnProps> = ({ item }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box px={4} py={2} gap={0} bg={cardBg} borderRadius="md" shadow="md" w="100%">
      <Flex justifyContent="space-between" alignItems="center">
        <LabelWithValueMobilePage hiddenColon label={item.name} />
        <VStack gap={0} pl={4}>
          <Text fontSize="1.3rem" color="gray.800">
            {item.number_of_vacancies}
          </Text>
          <Text mt={-1} fontSize="0.7rem" color="gray.500">
            Quantidade
          </Text>
        </VStack>
      </Flex>

      <MoreDetailVacancyMobilePage data={item} isOpen={isOpen} />
      <Divider my={2} color="gray.400" />
      <Flex gap={1} cursor="pointer" onClick={onToggle} justifyContent="center" alignItems="center">
        <Box transform={`rotate(${isOpen ? 180 : 0}deg)`} transition="transform 0.3s ease">
          <IoIosArrowDropdown />
        </Box>
        <Text>Mostrar {isOpen ? 'menos' : ''} detalhes</Text>
      </Flex>
    </Box>
  );
};

export default CardVacancyMobilePage;
